import PropTypes from "prop-types";
import React from "react";
import createReactClass from "create-react-class";
import Reflux from "reflux";
import { Link } from "react-router";
import _ from "lodash";
import Msg from "./Msg";
import { SessionStore } from "../../uidispatcherapi/SessionStore";
import { trackStructuredEvent } from "../../utils/TrackingUtil";
import CustomerStore from "../../stores/CustomerStore";

const customerSearchPath = "/backoffice/customer/search";

/**
 * the display of the current selected customer
 * displays search-link when not there
 *
 * this was extracted from HeaderEmployee.js
 */
const NaviCustomerInfo = createReactClass({
    displayName: "NaviCustomerInfo",

    propTypes: {
        selectRedirectsBack: PropTypes.bool.isRequired,
        selectEnabled: PropTypes.bool.isRequired
    },

    contextTypes: {
        router: PropTypes.object
    },

    mixins: [Reflux.listenTo(SessionStore, "onSessionUpdate"), Reflux.connect(CustomerStore, "customer")],

    trackCustomerSelectOrDeselect(select: boolean) {
        trackStructuredEvent(select ? "employeeNavigation.customerSelect" : "employeeNavigation.customerDeselect", {});
    },

    onDeselectCustomer() {
        this.trackCustomerSelectOrDeselect(false);
        SessionStore.clearSelectedCustomerId();
    },

    getRedirectUrlOnDeselect() {
        if (this.props.selectEnabled && this.props.selectRedirectsBack) {
            // No customer set but we are on a page where someone could see(click) the deselected customer button.
            // Goto to customer-search and then back the the old page
            return this.getRedirectUrl(customerSearchPath);
        } else {
            // do nothing, as we should be on a page that has no customer context or has its own selection
            return undefined;
        }
    },

    getInitialState() {
        return {
            selectedCustomerStore: SessionStore.getCustomerStore()
        };
    },

    onSessionUpdate() {
        const newStore = SessionStore.getCustomerStore();
        if (newStore) {
            this.setState({
                selectedCustomerStore: SessionStore.getCustomerStore()
            });
        }
    },

    calculateRedirectUrl(currentPath: string) {
        let path = currentPath;
        // remove the leading slash:
        if (_.isString(path) && path.charAt(0) === "/") {
            path = path.substr(1);
        }
        if (_.startsWith(path, "backoffice/customer/search/")) {
            path = path.substring("backoffice/customer/search/".length);
        } else if (_.startsWith(path, "backoffice/customer/search")) {
            path = path.substring("backoffice/customer/search".length);
        }
        // replace slashes within the path:
        // this is necessary because the customersearch page only accepts one parameter
        return encodeURIComponent(path);
    },

    handleSelectCustomer() {
        if (this.props.selectEnabled) {
            this.trackCustomerSelectOrDeselect(true);
        }
    },

    getRedirectUrl(path: string) {
        const currentPath = this.calculateRedirectUrl(this.context.router.location.pathname);
        const pushTo = {
            pathname: path + "/" + currentPath,
            query: this.context.router.location.query
        };
        return pushTo;
    },

    getUrlForSelectCustomer() {
        if (!this.props.selectEnabled) {
            return undefined;
        }
        if (this.props.selectRedirectsBack) {
            return this.getRedirectUrl(customerSearchPath);
        } else {
            return customerSearchPath;
        }
    },

    render() {
        //TODO(FD) change to component property, set from Page
        if (_.isEmpty(CustomerStore.getLoggedInName())) {
            return (
                <div className="extra-info">
                    <div className="clickable simple test-navi-select-customer" onClick={this.handleSelectCustomer}>
                        <Link to={this.getUrlForSelectCustomer()}>
                            <Msg k="EMPLOYEE_HEADER.PLEASE_SELECT" />
                        </Link>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="extra-info with-cancel">
                    <Link
                        to={this.getRedirectUrlOnDeselect()}
                        className="close test-navi-deselect-customer"
                        onClick={this.onDeselectCustomer}>
                        <span className="icon-close" />
                    </Link>
                    <div>
                        <div className="clickable header" onClick={this.handleSelectCustomer}>
                            <Link to={this.getUrlForSelectCustomer()}>{CustomerStore.getLoggedInName()}</Link>
                        </div>
                        <div className="customer-small customer-number">
                            {CustomerStore.getLoggedInCustomerDisplayNumber()}
                        </div>
                    </div>
                </div>
            );
        }
    }
});
export default NaviCustomerInfo;
